import { addValue } from '../actions';

export const HOST =
  process.env.NODE_ENV === 'production'
    ? `${window.location.origin}`
    : 'http://localhost:3000';
export const URL_PREFIX = '/angels';
export const MENTORS_URL = `${URL_PREFIX}/mentors`;

export const FORM_STATUS = {
  0: 'Черновик',
  14: 'На проверке',
  18: 'На согласовании',
  7: 'Отправлена',
};

export const FORM_LABELS = {
  0: 'success',
  14: 'primary',
  18: 'success',
  7: 'primary',
};

export const FORM_KIND = {
  '0': 'Участник',
  '24': 'Инвестор',
};

export const FORM_BUTTONS = {
  send: 'Отправить',
  withdraw: 'Отозвать',
};

export const INITIAL_RULES = {
  set_full_name: {
    valueName: 'ContactFullName',
    callback(dispatch, values) {
      if (
        typeof SK !== 'undefined' &&
        values.filter(value => value.id === 'ContactFullName').length <= 0
      ) {
        const { first_name, last_name, middle_name } = SK.user();
        let value = `${last_name || ''} ${first_name || ''} ${middle_name ||
          ''}`.trim();
        if (value && value.length > 0) {
          dispatch(addValue('ContactFullName', value, false));
        }
      }
    },
  },
  set_phone: {
    valueName: 'ContactPhone',
    callback(dispatch, values) {
      if (
        typeof SK !== 'undefined' &&
        values.filter(value => value.id === 'ContactPhone').length <= 0
      ) {
        const { phone } = SK.user();
        if (phone && phone.length > 0) {
          dispatch(addValue('ContactPhone', phone, false));
        }
      }
    },
  },
  set_email: {
    valueName: 'ContactEmail',
    callback(dispatch, values) {
      if (
        typeof SK !== 'undefined' &&
        values.filter(value => value.id === 'ContactEmail').length <= 0
      ) {
        const { email } = SK.user();
        if (email && email.length > 0) {
          dispatch(addValue('ContactEmail', email, false));
        }
      }
    },
  },
};

export const getFormTitle = ({ process_id }) => 'Заявка №' + process_id;
export const getFormSubtitle = ({ typeForm }) => typeForm || '';

export const PAGINATION = {
  page: 1,
  pagesize: 200,
  total: 0,
};
